import { useFormatMessage } from 'localization'
import React from 'react'
import { IntlContext } from 'react-intl'

export const useFormatPrice = (): ((price: number) => number | string) => {
  const { formatNumber } = React.useContext(IntlContext)
  const f = useFormatMessage()
  return (price: number) =>
    price === -1
      ? f('USE_FORMAT_PRICE_LABEL')
      : formatNumber(price, {
          style: 'currency',
          currency: 'SEK',
          minimumFractionDigits: 0,
        })
}
